require('./bootstrap')
import { UI } from './lib/ui.js'
import { AllUser } from './modules/all-user/all-user.js'
import { Content } from './modules/content/content.js'
import { Company } from './modules/company/company.js'
import { Flight } from './modules/flight/flight.js'
import { Player } from './modules/player/player.js'
import { Player_group } from './modules/player_group/player_group'
import { Playlist } from './modules/playlist/playlist.js'
import { PlaylistQueue } from './modules/playlist-queue/playlist-queue.js'
import { Roster } from './modules/roster/roster.js'
import { Template } from './modules/template/template.js'
import { Tickertape } from './modules/tickertape/tickertape.js'
import { User } from './modules/user/user.js'
import { WaitingRoom } from './modules/waiting-room/waiting-room.js'
import { Widget } from './modules/widget/widget.js'
new UI({
    'all-user' : AllUser,
    content : Content,
    company : Company,
    flight : Flight,
    player : Player,
    player_group : Player_group,
    playlist : Playlist,
    'playlist_queue' : PlaylistQueue,
    roster : Roster,
    template : Template,
    tickertape : Tickertape,
    user : User,
    'waiting-room' : WaitingRoom,
    widget : Widget
})//.hashRoute()